import { forOwn, isArray, isObject } from 'lodash-es'

export function flattenObject(obj, parentKey = '', result = {}) {
  forOwn(obj, (value, key) => {
    const newKey = parentKey ? `${parentKey}.${key}` : key
    if (isObject(value) && !isArray(value)) {
      flattenObject(value, newKey, result)
    } else {
      result[newKey] = value
    }
  })
  return result
}
